import actions from "@/store/modules/campaign/actions";
import mutations from "@/store/modules/campaign/mutations";
import state from "@/store/modules/campaign/state";

export default {
    actions,
    mutations,
    state
}